import { Injectable, Injector } from '@angular/core';
import {
    IChecklist2ForReport,
    IChecklistReportFilterItem,
    IChecklistReportFilterItemWithName,
    IChecklistScheduleForReport,
    IBusinessUnitForReport,
    IChecklistV2FilterAvailableItems,
    IChecklistV2ReportParameterFilter,
    IChecklist2ReportChecklistUnits,
    IChecklist2ReportAttentionRequired,
} from '../shared/fi-checklist2-report';
import { cloneDeep, isDefined } from '../../../utils';
import { IItemWithBusinessUnitId } from '../../../models/models';
import { fiIntersection } from '../../../utils/fi-intersection';
import { ChecklistProgressType } from '../enums/fi-checklist2-report-type';
import { FiChecklist2ReportHelperService } from './fi-checklist2-report-helper.service';
import { ILightWeightArea, ILightWeightObject } from '@fi-shared/models';
import { FiReportTableFilterHelperBase } from '@fi-shared/fi-report-table-filter/fi-report-table-filter-helper-base';
import { IReportMainItem } from '@fi-shared/fi-report-table-filter/fi-report-filter-base';

@Injectable()
export class FiChecklist2ReportFilterService extends FiReportTableFilterHelperBase {
    constructor(
        private fiChecklist2ReportHelperService: FiChecklist2ReportHelperService,
        injector: Injector,
    ) {
        super(injector);
    }

    //#region shared methods

    /*    private filterBySearchText<T extends IChecklistReportFilterItemWithName>(items: T[], searchText: string) {
        if (!searchText)
            return items;
        return items.filter((item: IChecklistReportFilterItemWithName) => {
            return item.ChecklistName.toLowerCase().includes(searchText.toLowerCase()) ||
                item.ScheduleName.toLowerCase().includes(searchText.toLowerCase());
        });
    }*/

    /*    private filterByAccessRights<T extends IChecklistReportFilterItem>(items: T[],
                                                                       filter: IChecklistV2ReportParameterFilter,
                                                                       availableChecklists: IChecklist2ForReport[],
                                                                       availableSchedules: IChecklistScheduleForReport[],
                                                                       filteredBusinessUnitIds: number[]): T[] {
        const filteredItems = items.filter(item => {
            if (filter.ChecklistIds?.length && filter.ChecklistIds.indexOf(item.ChecklistId) === -1) {
                return false;
            }
            if (filter.ScheduleIds?.length && filter.ScheduleIds.indexOf(item.ScheduleId) === -1) {
                return false;
            }
            const currentChecklist = availableChecklists.find(checklist => checklist.Id === item.ChecklistId);
            const currentSchedule = availableSchedules.find(schedule => schedule.Id === item.ScheduleId);
            if (!currentChecklist || !currentSchedule)
                return false;

            // filteredBusinessUnitIds contains available business unit ids, filtered by areas, units and business areas filter selection
            if (/!*!fiIntersection(filteredBusinessUnitIds, currentChecklist.BusinessUnitIds).length
                || *!/!fiIntersection(filteredBusinessUnitIds, currentSchedule.BusinessUnitIds).length)
                return false;

            return true;
        });
        return filteredItems;
    }*/

    /*private getBusinessUnitIdsByFilter(
        reportFilter: IChecklistV2ReportParameterFilter,
        availableBusinessUnits: IBusinessUnitForReport[],
    ): number[] {
        let businessUnitIds = availableBusinessUnits.map((item) => item.Id);
        if (reportFilter.BusinessUnitIds?.length) {
            businessUnitIds = fiIntersection(businessUnitIds, reportFilter.BusinessUnitIds);
        }
        if (reportFilter.AreaIds?.length) {
            const areaBusinessUnitIds = availableBusinessUnits
                .filter((bu) => reportFilter.AreaIds.includes(bu.AreaId))
                .map((bu) => bu.Id);
            businessUnitIds = fiIntersection(businessUnitIds, areaBusinessUnitIds);
        }
        if (reportFilter.BusinessAreaIds?.length) {
            const businessAreaBusinessUnitIds = availableBusinessUnits
                .filter((bu) => fiIntersection(reportFilter.BusinessAreaIds, bu.BusinessAreaIds).length)
                .map((bu) => bu.Id);
            businessUnitIds = fiIntersection(businessUnitIds, businessAreaBusinessUnitIds);
        }
        return businessUnitIds.filter((buId: number, index: number) => businessUnitIds.indexOf(buId) === index);
    }*/

    /*filterByBusinessUnitIds<T extends IItemWithBusinessUnitId>(items: T[], availableBusinessUnitsIds: number[]): T[] {
        return items.filter((item) => availableBusinessUnitsIds.includes(item.BusinessUnitId));
    }*/

    filterCheckpointsOrGroupsByChecklistIds<T extends { ChecklistId: number }>(
        items: T[],
        checklistIds: number[],
    ): T[] {
        const filteredItems = checklistIds ? items.filter((item) => checklistIds.includes(item.ChecklistId)) : items;
        return filteredItems;
    }

    //#endregion

    //#region Open checklists filtering

    filterChecklistDataByProgressType(
        items: IChecklist2ReportChecklistUnits[],
        checklistProgressType: ChecklistProgressType,
    ): IChecklist2ReportChecklistUnits[] {
        if (!isDefined(checklistProgressType)) return items;

        return items.filter((item) => {
            const filledCheckpointsCount: number =
                this.fiChecklist2ReportHelperService.getChecklistUnitsFilledCheckpoints(item);
            const totalCheckpointsCount: number =
                this.fiChecklist2ReportHelperService.getChecklistUnitsTotalCheckpoints(item);
            if (checklistProgressType === ChecklistProgressType.Completed) {
                return filledCheckpointsCount === totalCheckpointsCount;
            }
            if (checklistProgressType === ChecklistProgressType.NotStarted) {
                return !filledCheckpointsCount;
            }
            return filledCheckpointsCount > 0 && filledCheckpointsCount !== totalCheckpointsCount;
        });
    }

    //#endregion
}
